const engravingHelper = {
  getEngravingType(title) {
    if (title) {
      title = title.toLocaleLowerCase();

      if (title.includes('merch')) {
        return 'merch';
      }

      if (title.includes('bottle')) {
        return 'bottle';
      }
    }

    return '';
  }
};

export default engravingHelper;
